import * as actions from './actionTypes';
export function loadOrganisation(data) {
    return { type: actions.LOAD_ORGANISATION, payload: data };
}
